module.exports = __webpack_public_path__ + "img/beni-box.24249f6e.gif";